// Identity verification (KYC) - mirrors aceb-api risk/idv (UserKycStatus,
// KycStartResult, KycStatusResult). Keep in lockstep with the backend.

export enum KycStatus {
  None = 'none',
  Pending = 'pending',
  Approved = 'approved',
  Rejected = 'rejected',
  Expired = 'expired',
}

export interface KycStartResponse {
  kycStatus: KycStatus;
  // Hosted Ondato flow URL, present while a session is open. Opened in a new
  // tab so the cart survives; desktop shoppers get a QR handoff to the phone.
  redirectUrl?: string;
  sessionId?: string;
}

export interface KycStatusResponse {
  kycStatus: KycStatus;
  expiresAt?: string | null;
  retryable?: boolean;
  statusReason?: string;
}
